module.exports = __webpack_public_path__ + "img/Vegetable-Lasagna-4.239d83a0.jpg";